import { makeAutoObservable } from "mobx";
import { MeSchema } from "../../api/schemas/responses/users";
import { FetchStatusEnum, FetchStatusStrings } from "../../enums/fetchStatusEnum";
import { API } from "../../api/api";


// Ключ данных текущего пользователя в localStorage
const AuthUserKey: string = "user";


class AuthUserStore {
    user: MeSchema | undefined = JSON.parse(window.localStorage.getItem(AuthUserKey) || "null") || undefined;
    fetching: FetchStatusStrings = FetchStatusEnum.IDLE;

    constructor() {
        makeAutoObservable(this);
    }

    delete() {
        window.localStorage.clear();
        this.user = undefined;
    }

    update(newUserData: MeSchema) {
        try {
            window.localStorage.setItem(AuthUserKey, JSON.stringify(newUserData));
        } catch (err) {}
        this.user = newUserData;
    }

    get getMe(): MeSchema | undefined {
        if (this.user) return this.user;
        const storageUserData: string = window.localStorage.getItem(AuthUserKey) || "";
        this.user = storageUserData ? JSON.parse(storageUserData) : undefined;
        return this.user;
    }

    get isLogin(): boolean {
        return !!this.user;
    }

    setFetchStatus(newStatus: FetchStatusStrings): void {
        this.fetching = newStatus;
    }

    prefetchMe = () => {
        if (!authUserStore.isLogin) return;
        // Запрос уже в исполнении, не надо спамить на сервер - дождись завершения
        if (this.fetching === FetchStatusEnum.FETCHING) return;

        this.setFetchStatus(FetchStatusEnum.FETCHING);

        API.users
            .getMe()
            .then((user: MeSchema) => {
                this.setFetchStatus(FetchStatusEnum.SUCCESS);
                this.update(user);
            })
            .catch((reason) => {
                this.setFetchStatus(FetchStatusEnum.ERROR);
                if (400 <= reason.status && reason.status <= 499) {
                    this.delete();
                }
            });
    };
}

const authUserStore = new AuthUserStore();
export default authUserStore;
